import React, { Component } from 'react';
import $ from 'jquery';

class DetailsAuditoryModal extends Component{

    componentDidMount(): void {
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#DetailsAuditoryModal').modal('hide');  
    }

    closeAction = () => {
        $('#DetailsAuditoryModal').on('hidden.bs.modal', function () {
        });
    };
    Continue =()=>{
        $('#DetailsAuditoryModal').modal('hide');  
    }
    render() {
        const {getDetails} = this.props;
        return (
                <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="DetailsAuditoryModal" style={{zIndex: 91}}
                 role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-xl " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Detalles
                            </h4>
                            <button type="button" className="close" onClick={this.closeConfirm} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                {/*BODY*/}
                                                <div style={{marginBottom: 30}}>
                                                    <div style={{height: 400, overflow: 'auto'}}>
                                                        <table
                                                            // id="dataTableDocuments"
                                                            className="display"
                                                            style={{width: '100%',height:'200', marginBottom: 40, marginRight: -3000}}>
                                                            <thead className="table-header-yellow">
                                                            <tr style={{textAlign: "center"}}>
                                                                <td className="sticky-column sticky-header" style={{width: '25%',backgroundColor: '#d2ab24'}}>
                                                                    Artículo
                                                                </td>
                                                                <td className="sticky-header" style={{width: '25%',backgroundColor: '#d2ab24'}}>
                                                                    Descripción
                                                                </td>
                                                                <td className="sticky-header" style={{width: '25%',backgroundColor: '#d2ab24'}}>
                                                                    Almacén
                                                                </td>
                                                                <td className="sticky-header" style={{width: '10%',backgroundColor: '#d2ab24'}}>
                                                                    Cantidad 
                                                                </td>
                                                                <td className="sticky-header" style={{width: '15%',backgroundColor: '#d2ab24'}}>
                                                                    Valor 
                                                                </td>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                                {/* Filas de tabla  */}
                                                                {getDetails.map((item, index) => {
                                                                    return (     
                                                                        <tr style={{
                                                                            maxHeight: 10,
                                                                            paddingTop: 8,
                                                                            paddingBottom: 8,
                                                                            // color: item.stock ? 'black' : 'red',
                                                                            }}>

                                                                            {/*articulo*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.ItemCode ? item.ItemCode : ''}
                                                                                </td>
                                                                            {/*descricpion/}*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.ItemName ? item.ItemName : ''}
                                                                                </td>
                                                                            {/*Almacen*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.WhsCode ? item.WhsCode : ''}
                                                                                </td>
                                                                            {/*cantidad acumulada*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.AcQty ? item.AcQty : item.OutQty}
                                                                                </td>
                                                                            {/*valor*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.TransValue}
                                                                                </td>
                                                                        </tr>
                                                                    );
                                                                })} 
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeConfirm}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );  
    }
}
export default DetailsAuditoryModal;